import { Outlet } from "react-router-dom";
import NavbarComponent from "../components/NavbarComponent";
import SidebarComponent from "../components/SidebarComponent";

export default function HomePage() {
	return (
		<>
			<div className="d-flex" id="wrapper">
				<SidebarComponent />
				<div id="page-content-wrapper">
					<NavbarComponent />
					<div className="container-fluid">
						<Outlet />
					</div>
				</div>
			</div>
		</>
	);
}
